export const RPT_COLUMN_TOOLTIP = 'Related party transactions reported in MCA filings. Click to compare with GST and banking.';

export const RPT_VIEW_TRANSACTIONS_LABEL = 'View Transactions';

export const OTHER_KMP_TITLE = 'Other KMP or Their Relatives (Source - Related Party Transactions Filings)';

export const OTHER_KMP_TOOLTIP = 'Source: Related Party Transactions filings (MCA)';

export const RPT_DRAWER_TITLE = 'Transactions';

export const RPT_BANK_TXNS_BANNER = 'Click here to view individual banking transactions';

export const RPT_DRAWER_COLUMNS = {
    FY: 'Financial Year',
    TYPE: 'Transaction Type',
    MCA: 'MCA',
    GST: 'GST',
    BANKING: 'Banking',
} as const;

export const RPT_NOT_DISCLOSED = 'Not disclosed';

export const RPT_EMPTY_VALUE = '—';

export const RPT_BANKING_UNTAGGED_NOTE = 'No bank transactions are tagged to this party in the bank statements yet.';

export const RPT_GST_UNTAGGED_NOTE = 'No GST invoices are tagged to this party as a related party yet.';

export const RPT_BUCKET = {
    INDIVIDUAL: 'individual',
    OTHERS: 'others',
} as const;
